import { render, staticRenderFns } from "./AdminLegExportDialog.vue?vue&type=template&id=8efc2cca"
import script from "./AdminLegExportDialog.vue?vue&type=script&lang=js"
export * from "./AdminLegExportDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports